export const floatingMenu = {
  floatingMenuMenu: "Menú",
  floatingMenuHome: "Inicio",
  floatingMenuGames: "Juegos",
  floatingMenuSlots: "Slots",
  floatingMenuSports: "Deportes",
  floatingMenuLottery: "Lotería",
  floatingMenuCasino: "Casino",
  floatingMenuFeed: "Feed",
  floatingMenuBingo: "Bingo",
  floatingMenuToPlay: "Jugar",
  floatingMenuCategories: "Categorías",
  floatingMenuSeeAllGames: "Ir a todos los juegos",
  floatingMenuSeeAllSports: "Ir a todos",
};
